// DonutIndicator — base donut/composition chart of the Analysis view
// (US-879 · R-2/R-6). Thin Recharts wrapper over already-built rows
// ({ name, value, color }) from config/analysisConfig.js; per-slice colors
// are theme tokens. US-880/881 reuse it via new config entries.
import Box from "@mui/material/Box";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { colors, fonts } from "../../../theme/tokens";

// data: [{ name, value, color }]; valueFormatter formats tooltip values.
const DonutIndicator = ({ data, valueFormatter }) => (
  <Box sx={{ width: "100%", height: 220 }}>
    <ResponsiveContainer width="100%" height="100%">
      <PieChart margin={{ top: 4, right: 4, bottom: 4, left: 4 }}>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          innerRadius="55%"
          outerRadius="80%"
          paddingAngle={2}
          stroke="none"
        >
          {data.map((row) => (
            <Cell key={row.name} fill={row.color} />
          ))}
        </Pie>
        <Tooltip
          formatter={(value) => (valueFormatter ? valueFormatter(value) : value)}
          contentStyle={{
            fontFamily: fonts.sans,
            fontSize: 12,
            border: `1px solid ${colors.borderLight}`,
            borderRadius: 6,
          }}
        />
        <Legend
          verticalAlign="bottom"
          iconType="circle"
          iconSize={9}
          wrapperStyle={{ fontFamily: fonts.sans, fontSize: 12 }}
        />
      </PieChart>
    </ResponsiveContainer>
  </Box>
);

export default DonutIndicator;
